import AutocompleteSelect from "./Components/Autocomplete/Autocomplete";
import "./index.css";

function App() {
  return (
    <div className="page-control">
      <AutocompleteSelect />
    </div>
  );
}

export default App;
